// libraries
import clsx from 'clsx'

// components
import RichText from '/react4xp/components/RichText'

// svg
import { CheckCircle } from '/react4xp/components/Icons/Ux'

// utils
import { limitCharacters } from '/react4xp/utils/functions'

// css
import './index.scss'

// types
export interface HighlightsProps {
    className?: string
    items?: {
        title?: string
        description?: string
    }[]
}

export default function Highlights({
    className,
    items
}: HighlightsProps) {
    return (
        <section className={clsx('highlights-component', className)}>
            <div className='container'>
                <div className='row'>
                    {items?.map((item, i) => (
                        <div
                            key={i}
                            className='col-12 col-lg-4'
                        >
                            <div className='highlights-component__item'>

                                <CheckCircle />

                                <div className='highlights-component__item__content'>

                                    {item.title && (
                                        <h3 className='h3'>
                                            {item.title}
                                        </h3>
                                    )}

                                    {item.description && (
                                        <RichText>
                                            {limitCharacters(item.description, 250)}
                                        </RichText>
                                    )}

                                </div>

                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}